<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Assigned Terminals</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <all-assigned-terminals-table />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * View Fixed Deposit Component
 */

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import AllAssignedTerminalsTable from "@/components/Kleyton/Tables/Terminal/AllAssignedTerminalsTable";

export default {
  page: {
    title: "Assigned Terminals",
    meta: [{ name: "Assigned Terminal", content: window.__env.app.description }]
  },
  components: {
    AllAssignedTerminalsTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Assigned Terminals",

      items: [
        {
          text: "Terminal",
          href: "/"
        },
        {
          text: "Assigned Terminals",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
